import { render } from "./app-format-currency.vue?vue&type=template&id=28f40e23&ts=true"
import script from "./app-format-currency.vue?vue&type=script&lang=ts"
export * from "./app-format-currency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__